import { useMutation, useQuery } from "@tanstack/react-query";
import axiosInstance from "./axios";

export interface GetBankingTransactionsRequest {
  branchId: number;
  counterId: number;
  staffId?: number;
  fromDate: string;
  toDate: string;
  pageNo: number;
  pageSize: number;
}

export interface Transaction {
  id: number;
  referenceNumber: string;
  transactionDate: string;
  transactionType: string;
  mode: string;
  category: string;
  cashIn: number;
  cashOut: number;
  balance: number;
  remarks: string;
  createdBy: string;
}

export interface TransactionPage {
  content: Transaction[];
  pageNumber: number;
  pageSize: number;
  totalElements: number;
  totalPages: number;
  isLast: boolean;
}

export interface BankingTransactionsResponse {
  transactions: TransactionPage;
  pageCashIn: number;
  pageCashOut: number;
  totalCashIn: number;
  totalCashOut: number;
}

export interface CreateTransactionPayload {
  referenceNumber: string;
  transactionDate: string; // ISO date (YYYY-MM-DD)
  transactionType: "CASH_IN" | "CASH_OUT" | "BANK_IN" | "BANK_OUT";
  mode: "CASH" | "BANK";
  category:
    | "EXPENSE"
    | "SALARY"
    | "RENT"
    | "BILL_PAYMENT"
    | "COMMISSION"
    | "TRANSFER";
  referenceId: string;
  amount: number;
  remarks: string;
}
export const useGetAllBankingTransactions = ({
  params,
}: {
  params: GetBankingTransactionsRequest;
}) => {
  return useQuery({
    queryKey: ["useGetAllBankingTransactions", params],
    queryFn: async () => {
      const { data } = await axiosInstance.get("/bank-transactions/get-all", {
        params,
      });
      return data as BankingTransactionsResponse;
    },
    enabled: !!params,
  });
};

export const usePostBankingTransaction = () => {
  return useMutation({
    mutationFn: async (postData: CreateTransactionPayload) => {
      const { data } = await axiosInstance.post(
        "/bank-transactions/create",
        postData,
      );
      return data;
    },
  });
};
